import { matchPath } from "react-router-dom";
import {
  ROLE_PERMISSIONS,
  isDeliveredPlanogramViewerOnly,
  type RoleCode,
} from "@CommonUtils/RolesPermissions";
import { pages } from "src/utils/pages";

/**
 * The only pages a delivered-planogram viewer (the store viewer role) can open. Everything else
 * sends it back to Space Planning; the backend refuses those pages' requests anyway.
 */
export const PLANOGRAM_VIEWER_ALLOWED_PAGES = [
  pages.spacePlanning,
  pages.storeViewer_storePogId_,
  pages.profile,
  pages.logout,
] as const;

export const PLANOGRAM_VIEWER_HOME = pages.spacePlanning;

// A missing or unknown role is not narrowed here; the backend refuses whatever it may not read.
export const isPlanogramViewerOnlyUser = (user: { roleCode: RoleCode } | null | undefined) =>
  Boolean(
    user &&
    Object.hasOwn(ROLE_PERMISSIONS, user.roleCode) &&
    isDeliveredPlanogramViewerOnly(user.roleCode),
  );

export const isPathOpenToPlanogramViewer = (pathname: string) =>
  PLANOGRAM_VIEWER_ALLOWED_PAGES.some((path) => matchPath({ path, end: true }, pathname) !== null);
